// Master-Prompt v2.6.6 §1.2-§1.9 Hotfixes B-I — 5 Fragen v5 mit überarbeiteten
// Antworten und Setup-Texten. Hotfix J — Steckbrief + Konflikt-Spiegel in
// FRANK-STIL (alltagsnäher, OHNE "gegenüberliegender Fokustyp"-Vokabular).

// Sprint 12+I3 Hotfix (04.07.2026) — Dean's v4-Fragen fuer den Landing-Page-
// Quick-Check (identisch zu /pionier-quick-check). Antwort-Reihenfolge FEST
// A/B/C/D alphabetisch nach Fokustyp (Eule/Biene/Katze/Hund). KEIN Shuffle.
// Sprint V38.1 Hotfix (15.09.2026) — Variante B: Situationen + Fragen +
// Antworten gekürzt für niedrigere Einstiegshürde auf Landing-Page-QuickTest.
// Semantik + Fokustyp-Zuordnung bleiben identisch zu v4.
export const QUICK_TEST_QUESTIONS = [
  {
    id: 1,
    situation: "Ein Freund erzählt dir von einem Problem.",
    text: "Was tust du?",
    options: [
      { key: "a", label: "Ich höre zu und versuche zu verstehen, was dahinter steckt.", fokustyp: "eule" },
      { key: "b", label: "Ich frage nach Fakten und überlege eine sinnvolle Lösung.", fokustyp: "biene" },
      { key: "c", label: "Ich halte mich zurück — betrifft mich das überhaupt?", fokustyp: "katze" },
      { key: "d", label: "Ich spüre, wie er sich fühlt, und tröste ihn.", fokustyp: "hund" },
    ],
  },
  {
    id: 2,
    situation: "Ihr diskutiert die Wochenendplanung.",
    text: "Was ist dir am wichtigsten?",
    options: [
      { key: "a", label: "Ich will verstehen, welche Optionen wirklich Sinn machen.", fokustyp: "eule" },
      { key: "b", label: "Ich mache einen klaren Plan mit festen Schritten.", fokustyp: "biene" },
      { key: "c", label: "Ich will entscheiden, was mir Spaß macht — nicht andere.", fokustyp: "katze" },
      { key: "d", label: "Mir ist wichtig, dass wir beide zufrieden sind.", fokustyp: "hund" },
    ],
  },
  {
    id: 3,
    situation: "Eine Kollegin kommt ständig zu spät.",
    text: "Wie reagierst du?",
    options: [
      { key: "a", label: "Ich spreche es sachlich an und will die Gründe verstehen.", fokustyp: "eule" },
      { key: "b", label: "Ich schlage eine klare Regel vor: pünktlich beginnen.", fokustyp: "biene" },
      { key: "c", label: "Sie soll selbst entscheiden, wie sie ihre Zeit organisiert.", fokustyp: "katze" },
      { key: "d", label: "Ich rede unter vier Augen — vielleicht steckt was dahinter.", fokustyp: "hund" },
    ],
  },
  {
    id: 4,
    situation: "Dein Teenager verdreht die Augen bei deiner Frage.",
    text: "Wie gehst du damit um?",
    options: [
      { key: "a", label: "Ich will verstehen, warum sie/er so reagiert.", fokustyp: "eule" },
      { key: "b", label: "Ich erkläre ruhig, warum die Sache wichtig ist.", fokustyp: "biene" },
      { key: "c", label: "Ich lasse sie/ihn in Ruhe — zwingen bringt nichts.", fokustyp: "katze" },
      { key: "d", label: "Ich spüre, ob Stress dahinter steckt, und gehe darauf ein.", fokustyp: "hund" },
    ],
  },
  {
    id: 5,
    situation: "In einer Gruppe stellt jemand deine Meinung infrage.",
    text: "Was tust du?",
    options: [
      { key: "a", label: "Ich bleibe sachlich und bringe meine Argumente klar.", fokustyp: "eule" },
      { key: "b", label: "Ich kläre strukturiert, damit am Ende alle wissen, wo wir stehen.", fokustyp: "biene" },
      { key: "c", label: "Meine Meinung steht — ob andere zuhören, ist deren Sache.", fokustyp: "katze" },
      { key: "d", label: "Mir ist wichtig, dass die Gruppenstimmung gut bleibt.", fokustyp: "hund" },
    ],
  },
];

export const W_FRAGE_BY_FOKUSTYP = {
  eule: "WAS",
  biene: "WIE",
  katze: "WARUM",
  hund: "WER",
};

// FRANK-STIL (Hotfix J) — alltagsnäher, weicher, kein Coaching-Vokabular.
export const STECKBRIEF_BY_FOKUSTYP = {
  eule:
    "Du willst verstehen, bevor du mitmachst. Wenn etwas keinen Sinn ergibt, gehst du nicht mit. Das macht dich unbequem — aber auch jemand, dem man vertraut.",
  biene:
    "Du willst, dass Dinge laufen. Klarheit, Verlässlichkeit, Zuständigkeit — das ist dein Stoff. Wenn du dich einmal entschieden hast, hältst du es am Laufen.",
  katze:
    "Du gehst nur dorthin, wo es sich für dich lohnt. Nicht aus Egoismus — sondern weil du spürst, dass deine Energie endlich ist. Wenn du willst, gehst du voll rein. Wenn nicht, ist Widerstand zwecklos.",
  hund:
    "Du merkst sofort, wenn die Stimmung kippt. Das ist anstrengend, aber auch deine Stärke. Du hältst Gruppen zusammen, auch wenn es dich selbst was kostet.",
};

// FRANK-STIL Konflikt-Spiegel — OHNE "gegenüberliegender Fokustyp"-Vokabular.
// Hotfix-Sprint 11.6 (Block 1.5) — Eröffnung: ARTIKEL „Der Fokustyp" statt
// Pronomen „Dein Fokustyp", da im UI bereits „Fokustyp {Name}" als Label
// gezeigt wird. Vermeidet 3-fach-Redundanz im ResultMirror-Block.
export const DIAGONALE_BY_FOKUSTYP = {
  eule: {
    diagonale: "hund",
    konflikt:
      "Der Fokustyp, mit dem du am ehesten in Konflikt gerätst, ist der Hund. Er achtet auf die Menschen — du achtest auf die Sache. Ihr wollt beide dasselbe Gespräch führen, aber aus ganz verschiedenen Blickwinkeln. Das ist der Grund, warum es manchmal knirscht.",
  },
  biene: {
    diagonale: "katze",
    konflikt:
      "Der Fokustyp, mit dem du am ehesten in Konflikt gerätst, ist die Katze. Sie will mitmachen, wenn es sich lohnt — du willst, dass es läuft. Wenn sie sich drückt, fühlst du dich im Stich gelassen. Wenn du drückst, fühlt sie sich eingeengt. Beides ist berechtigt.",
  },
  katze: {
    diagonale: "biene",
    konflikt:
      "Der Fokustyp, mit dem du am ehesten in Konflikt gerätst, ist die Biene. Sie hält Dinge am Laufen — du gehst nur dorthin, wo es sich für dich lohnt. Sie plant, du entscheidest spontan. Das ist der Spagat, der euch manchmal reibt.",
  },
  hund: {
    diagonale: "eule",
    konflikt:
      "Der Fokustyp, mit dem du am ehesten in Konflikt gerätst, ist die Eule. Sie denkt mehr nach, du spürst mehr. Das ist der Grund, warum es manchmal knirscht: zwei Wege, die sich nicht treffen, obwohl sie dasselbe Ziel haben.",
  },
};

export const FOKUSTYP_NAME = {
  eule: "Eule",
  biene: "Biene",
  katze: "Katze",
  hund: "Hund",
};

// Master-Prompt v2.6.7 §A — Antwort-Reihenfolge pro Frage shuffeln.
// Fisher-Yates auf einer Kopie, damit das Original-Array unverändert bleibt.
export function shuffleArray(arr) {
  const out = arr.slice();
  for (let i = out.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}

// Tie-Break aus v2.5 §4.3.1 (FINAL): Eule > Biene > Hund > Katze
//
// ⚠️ BUSINESS-LOGIC, NICHT UI. Dies bestimmt, welcher Fokustyp bei Gleichstand
// gewinnt (z.B. wenn Katze und Hund beide 3 Punkte haben, gewinnt Hund).
// Anzeige-Reihenfolge fuer UI ist FOKUSTYP_DISPLAY_ORDER in FokustypGlyphs.jsx.
// Sprint-V24 Issue S (11.02.2026) Plausibilitaetscheck: die Reihenfolgen SIND
// unterschiedlich, das ist beabsichtigt — nicht angleichen ohne Produkt-Freigabe.
export const TIE_BREAK_ORDER = ["eule", "biene", "hund", "katze"];

export function scoreQuickTest(answers) {
  const scores = { eule: 0, biene: 0, katze: 0, hund: 0 };
  for (const ans of answers || []) {
    const q = QUICK_TEST_QUESTIONS.find((x) => x.id === ans.question_id);
    if (!q) continue;
    const opt = q.options.find((o) => o.key === ans.choice);
    if (!opt) continue;
    scores[opt.fokustyp] += 1;
  }
  const sorted = Object.keys(scores).sort(
    (a, b) => scores[b] - scores[a] || TIE_BREAK_ORDER.indexOf(a) - TIE_BREAK_ORDER.indexOf(b),
  );
  const dominant = sorted[0];
  return {
    dominant_fokustyp: dominant,
    w_frage: W_FRAGE_BY_FOKUSTYP[dominant],
    steckbrief: STECKBRIEF_BY_FOKUSTYP[dominant],
    diagonale_fokustyp: DIAGONALE_BY_FOKUSTYP[dominant].diagonale,
    diagonale_w_frage: W_FRAGE_BY_FOKUSTYP[DIAGONALE_BY_FOKUSTYP[dominant].diagonale],
    konflikt_spiegel: DIAGONALE_BY_FOKUSTYP[dominant].konflikt,
    scores,
  };
}
